import { lookupDiffItemAcrossGrades } from "../hooks/ratings/diff/enrichDiffItems";

const cloneTree = (data) => JSON.parse(JSON.stringify(data || []));

/**
 * Parent preview: profile DTOs leave off-template diffs (often 7th/8th) as nameless
 * nodes with grade: null, which used to drop them from the consolidated report.
 * Restore grade + labels from reportable content and/or getStudentRatings
 * (all_ratings) diff rows — student_diff is not the source of truth here.
 */
export const enrichGuardianDiffHierarchy = (criteriaList, { reportableContent, diffRatings } = {}) => {
    if (!criteriaList?.length) return criteriaList || [];
    if (!reportableContent && !diffRatings?.length) return criteriaList;

    const gradeByContentId = new Map();
    (diffRatings || []).forEach((dr) => {
        if (dr?.contentId != null && dr.grade) {
            gradeByContentId.set(String(dr.contentId), dr.grade);
        }
    });

    const cloned = cloneTree(criteriaList);

    const apply = (holder, standard, gle, eo) => {
        const dr = holder?.diffRating;
        if (!dr || dr.contentId == null) return;
        const lookedUp = lookupDiffItemAcrossGrades(reportableContent, dr.contentId);
        const grade = dr.grade || lookedUp?.grade || gradeByContentId.get(String(dr.contentId)) || null;
        if (grade && !dr.grade) {
            holder.diffRating = { ...dr, grade };
        }
        if (!lookedUp) return;
        if (standard && !standard.cdestandardBody) standard.cdestandardBody = lookedUp.standardName;
        if (standard && standard.cdestandardId == null && lookedUp.standardKey != null) {
            standard.cdestandardId = lookedUp.standardKey;
        }
        if (gle && !gle.gleBody) gle.gleBody = lookedUp.gleName;
        if (gle && gle.gleId == null && lookedUp.gleKey != null) {
            gle.gleId = lookedUp.gleKey;
        }
        if (eo && !eo.eoBody && lookedUp.contentType !== "GLE") {
            eo.eoBody = lookedUp.label;
        }
    };

    cloned.forEach((criteria) => {
        (criteria.cdeStandards || []).forEach((standard) => {
            (standard.gles || []).forEach((gle) => {
                apply(gle, standard, gle, null);
                (gle.evidenceOutcomes || []).forEach((eo) => {
                    apply(eo, standard, gle, eo);
                    (eo.evidenceOutcomeChildren || []).forEach((child) => {
                        apply(child, standard, gle, eo);
                    });
                });
            });
        });
    });

    return cloned;
};
